var exports = {
  "o": "xa15a2ab7--9163cf--address-line",
};

module.exports = exports;
